<!--
frontend-author:bhavya, Vaishnavi,
page-name : RetainerInvoice.vue,
page-description : RetainerInvoice for invoice,
started at : 24-june-2019,
-->

<template>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="RetainerInvoiceCreate">
        <template slot="title">
          <h2>Its time to save!!!</h2>
        </template>
        <template slot="content">
          <span style="color:gray">The place where savings comes before payment</span>
        </template>
        <template slot="page">New Customer Deposit</template>
      </GlobalEmptyRecord>
    </div>
    <div class="start-page" v-else style="margin-top:-10px !important">
      <!-- Header block -->
      <template v-if="CheckedCount == 0">
        <b-row class="px-pad border-bottom" style="height:42px">
          <b-col cols="8" class="px-0">
            <b-dropdown
              variant="link"
              class="index-filter-heading"
              size="sm"
              dropdown
              toggle-class="text-decoration-none"
              :text="filter_name"
            >
              <div class="dropdownitem-list">
                <b-dropdown-item
                  :class="{'filter_dropdown' : true}"
                  :to="{ name : 'RetainerInvoice',query: {page: 1 ,show: 10,search:'',status:item.status_id,sort:sort,label:label} }"
                  v-for="item in filter_list"
                  :key="item.status_id"
                  v-if="item.status_name != filter_name"
                >{{ item.status_name }}</b-dropdown-item>
              </div>
              <b-dropdown-divider />
              <router-link
                class="event-link dropdown-item"
                :to="{ name : 'FilterCreate',params : {title :'Customer Deposit',module:'retainer',call:'fetchRetainerInvoiceDetails',route:'retainer'}}"
              >Add Custom Filter</router-link>
            </b-dropdown>
            <router-link
              class="event-link"
              v-if="status >= 100"
              :to="{ name : 'FilterUpdate',params : {id:getPresentValue(filter_list,'status_name',filter_name),title :'Customer Deposit',module:'retainer',call:'fetchRetainerInvoiceDetails',route:'retainer'}}"
            >
              <b-button size="xs" style="position:relative;bottom:4px;" variant="light">
                <i class="la la-edit la-lg"></i>
              </b-button>
            </router-link>
          </b-col>
          <b-col cols="4" class="text-right px-0">
            <router-link
              :to="{ name : 'RetainerInvoiceCreate'}"
              v-if=" RoutePermission(true,'RetainerInvoiceCreate','','','')"
            >
              <b-button variant="primary" size="sm" class="mr-2">New Customer Deposit</b-button>
            </router-link>
            <b-button variant="light" size="sm" class="mr-2" @click="getrefreshList()">
              <i class="la la-refresh la-lg"></i>
            </b-button>
            <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
              <template slot="button-content">
                <i class="la la-navicon la-lg"></i>
              </template>
              <template v-if="RoutePermission(false,'','','settings','export')">
                <b-dropdown-item @click="exportModal()">
                  <span class="no_caret_import la la-download mr-3"></span>Export CustomerDeposit
                </b-dropdown-item>
                <b-dropdown-divider />
              </template>
              <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
              <div class="dropdownitem-block">
                <li class="ml-3">
                  <b-form-checkbox name="retainer_notes" v-model="retainer_notes" value="1">Notes</b-form-checkbox>
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="refund_amount"
                    v-model="refund_amount"
                    value="2"
                  >Refund amount</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="ref_no" v-model="ref_no" value="1">Reference No</b-form-checkbox>
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="available_amount"
                    v-model="available_amount"
                    value="3"
                  >Available amount</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="used_amount" v-model="used_amount" value="4">Used amount</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox name="created_at" v-model="created_at" value="5">Created Time</b-form-checkbox>
                </li>
                <li class="ml-3 pt-2 pb-2">
                  <b-form-checkbox name="updated_at" v-model="updated_at" value="6">Updated Time</b-form-checkbox>
                </li>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" class="px-0">
          <b-row style="height:42px" class="px-pad border-bottom" v-if="CheckedCount > 0">
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" class="px-pad">
              <!--  delete the selected invoice -->
              <b-button
                size="sm"
                variant="light"
                class="text-left"
                @click="deletemodal"
                :disabled="!RoutePermission(false,'','invoice','paymentsreceived','delete')"
              >
                <i
                  class="glyphicon glyphicon-trash"
                  v-b-tooltip="!RoutePermission(false,'','invoice','paymentsreceived','delete')?' You do not have permission to perform this operation. Please contact your Administrator. ':''"
                ></i>
              </b-button>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" class="px-pad">
              <i
                v-on:click="checkAll({
                    target :{
                      checked : false
                    }
                  
                  }),CheckedCount = 0,checkboxes1[0]=false"
                class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
              ></i>
            </b-col>
          </b-row>
          <!-- search criteria alert -->
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{ name : 'RetainerInvoice',query: {page: page ,show: count,search:'',sort:sort,label:label} }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span
                class="fw-semi-bold"
              >Customer Name / Customer ID / Company name / Payment No / Reference No :</span>
              {{ this.$route.query.search }}
            </p>
          </b-alert>
          <!-- Table for details -->
          <div
            :class="this.$route.params.search=='' ?'table-responsive':'table_search'"
            id="scrollCol"
          >
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th style="width:54px !important">
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        id="checkboxall"
                        v-model="checkboxes1[0]"
                        @change="event => checkAll(event)"
                      />
                      <label for="checkboxall" />
                    </div>
                  </th>
                  <th style="min-width:85px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'retainer_no',custom:custom} }"
                    >
                      ID
                      <small class="text-muted" v-if="label == 'retainer_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'retainer_date',custom:custom} }"
                    >
                      Date
                      <small class="text-muted" v-if="label == 'retainer_date'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th style="min-width:135px !important" v-if="ref_no==1">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'ref_no',custom:custom} }"
                    >
                      Ref No.
                      <small class="text-muted" v-if="label == 'ref_no'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:200px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'cus_name',custom:custom} }"
                    >
                      Customer
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:180px !important" v-if="retainer_notes==1">Notes</th>

                  <!-- <th width="15%" >
                    <router-link
                      class="text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pjt_name'} }"
                    >
                      PROJECT
                      <small class="text-muted" v-if="label == 'pjt_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                    
                  </th>-->

                  <th style="min-width:110px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'retainer_status_name',custom:custom} }"
                    >
                      STATUS
                      <small class="text-muted" v-if="label == 'retainer_status_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th
                    class="text-right"
                    style="min-width:140px !important"
                    v-if="refund_amount==2"
                  >Refund Amt.</th>
                  <th
                    class="text-right"
                    style="min-width:140px !important"
                    v-if="available_amount==3"
                  >Available Amt.</th>
                  <th
                    class="text-right"
                    style="min-width:140px !important"
                    v-if="used_amount==4"
                  >Used Amt.</th>
                  <th class="text-right" style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'retainer_total',custom:custom} }"
                    >
                      Amount
                      <small class="text-muted" v-if="label == 'retainer_total'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>

                  <th class="text-right" style="min-width:140px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'due_amount',custom:custom} }"
                    >
                      Balance
                      <small class="text-muted" v-if="label == 'due_amount'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:300px !important" v-if="created_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'created_at',custom:custom} }"
                    >
                      Created Time
                      <small class="text-muted" v-if="label == 'created_at'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width:300px !important" v-if="updated_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'RetainerInvoice',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'updated_at',custom:custom} }"
                    >
                      Updated Time
                      <small class="text-muted" v-if="label == 'updated_at'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th class="text-right" style="width:30px !important"></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="11" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(list,index) in lists" :key="list.retainer_hdr_id">
                    <td>
                      <div class="abc-checkbox index-checkbox text-left">
                        <input
                          type="checkbox"
                          v-model="checkboxes1[index + 1]"
                          :id="'checkbox'+(index+1)"
                          :true-value="list.retainer_hdr_id"
                          :value="list.retainer_hdr_id"
                          @change="event => changeCheck(event, 'checkboxes1', index+1)"
                        />
                        <label :for="'checkbox'+(index+1)" />
                      </div>
                    </td>
                    <td
                      v-if="RoutePermission(false,'','invoice','paymentsreceived','index')"
                      class="text-nowrap"
                    >
                      <router-link
                        class="event-link theme-text-color"
                        :to="{ name : 'RetainerInvoiceView',params:{id:list.retainer_hdr_id}}"
                      >{{list.retainer_no}}</router-link>
                    </td>
                    <td v-else class="btn-link theme-text-color text-nowrap">{{list.retainer_no}}</td>
                    <td>{{ getDateFormat(list.retainer_date) }}</td>

                    <td v-if="ref_no==1" class="text-nowrap">{{ list.ref_no}}</td>
                    <td style="max-width:200px !important">
                      <span class="text">{{ list.cus_name }}</span>
                    </td>
                    <td style="width:180px !important" v-if="retainer_notes==1">
                      <span class="text">{{list.retainer_notes}}</span>
                    </td>

                    <!-- <td>{{ list.pjt_name }}</td> -->

                    <td>{{list.retainer_status_name}}</td>
                    <td v-if="refund_amount==2" class="text-right">
                      {{ 
                      getDetails(
                      $AppDetails.currency_details,
                      list.cus_currency,
                      "currency_symbol"
                      )+" "+parseFloat(list.refund_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </td>
                    <td v-if="available_amount==3" class="text-right">
                      {{
                      getDetails(
                      $AppDetails.currency_details,
                      list.cus_currency,
                      "currency_symbol"
                      )+" "+parseFloat(list.available_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </td>
                    <td v-if="used_amount==4" class="text-right">
                      {{
                      getDetails(
                      $AppDetails.currency_details,
                      list.cus_currency,
                      "currency_symbol"
                      )+" "+ parseFloat(list.used_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </td>
                    <td class="text-right">
                      {{ 
                      getDetails(
                      $AppDetails.currency_details,
                      list.cus_currency,
                      "currency_symbol"
                      )+" "+parseFloat(list.retainer_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </td>

                    <td class="text-right">
                      {{ 
                      getDetails(
                      $AppDetails.currency_details,
                      list.cus_currency,
                      "currency_symbol"
                      )+" "+parseFloat(list.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </td>
                    <td v-if="created_at">
                      <span class="text">{{ displayDateTime(list.created_at) }}</span>
                    </td>
                    <td v-if="updated_at">
                      <span class="text">{{ displayDateTime(list.updated_at) }}</span>
                    </td>
                    <td class="text-right">
                      <router-link
                        v-if="RoutePermission(false,'','invoice','paymentsreceived','update')"
                        class="event-link theme-text-color text-decoration-none"
                        :to="{ name : 'RetainerInvoiceUpdate',params:{id:list.retainer_hdr_id}}"
                      >
                        <i class="la la-edit la-lg theme-text-color table-hover-visible"></i>
                      </router-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <!-- page and its details -->
      <b-row
        v-if="lists.length > 0"
        style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" class="mt-2 pt-1 px-0">
          <nav class="float-left">
            <p>
              Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
              of {{ total_count }} entries
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :show="false"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{ name : 'RetainerInvoice',query: {page: 1,show: 10,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name : 'RetainerInvoice',query: {page: 1,show: 25,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name : 'RetainerInvoice',query: {page: 1 ,show: 50,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                  </router-link>
                </b-dropdown>
              </span> rows per page
            </p>
          </nav>
        </b-col>
        <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
          <div v-if="arrow">
            <a @click="left('#scrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#scrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
          <!-- Pagination -->
          <template v-if="show<total_count">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{ name : 'RetainerInvoice',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RetainerInvoice',query: {page: 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                  >First</router-link>
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{ name : 'RetainerInvoice',query: {page: page - 1 ,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom} }"
                    >Previous</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > (page * count)">
                    <router-link
                      class="page-link"
                      :to="{ name : 'RetainerInvoice',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                    >Next</router-link>
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{ name : 'RetainerInvoice',query: {page: Math.ceil(total_count / count),show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                  >Last</router-link>
                </li>
                <li class="page-item">
                  <template v-if="total_count > (page * count)">
                    <router-link
                      class="page-link"
                      :to="{ name : 'RetainerInvoice',query: {page: page + 1,show: count,search:search_criteria,status:status,sort:sort,label:label,custom:custom } }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
      <!--  bulk delete modal -->
      <DeleteRecord
        v-on:setDelete="getDelete"
        :value="value"
        module="retainer"
        content="The selected customer deposit(s) will be deleted and cannot be retrieved later. Are you sure about deleting them?"
      ></DeleteRecord>
      <LogRecord :message="logrecords"></LogRecord>
      <GlobalExportModal
        v-if="export_modal"
        :data="export_data"
        :columns="export_xl"
        :file_name="'Customer Deposit'"
        @downloaded="export_modal=false"
      />
    </div>
</template>
<script>
// import all the components, files and funciton
import { mapState } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import DeleteRecord from "@/components/Modal/DeleteModal"; // modal for deleting created credit used record
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import $ from "jquery";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
//pages
function getPageRetainers(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status = routeTo.query.status || store.state.retainer.index_status || 1;
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";
  store
    .dispatch("retainer/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom
    })
    .then(response => {
      if (search != "" && response.status == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
       else {
        store.dispatch("retainer/fetchRetainerInvoiceDetails");
      }

      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable, formatDate], //call the global mixin function
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number]
  },
  name: "Retainer",

  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      created_at: "",
      updated_at: "",
      export_xl: {
        ID: "retainer_no",
        Date: "retainer_date",
        Number: "ref_no",
        Customer: "cus_name",
        Notes: "retainer_notes",
        STATUS: "retainer_status_name",
        "Refund Amount(BCY)": "refund_amount",
        "Refund Amount(FCY)": "export_refund_amount",
        "Available Amount(BCY)": "available_amount",
        "Available Amount(FCY)": "export_available_amount",
        "Used Amount(BCY)": "used_amount",
        "Used Amount(FCY)": "export_used_amount",
        "Amount(BCY)": "retainer_total",
        "Amount(FCY)": "export_retainer_total",
        "Balance(BCY)": "due_amount",
        "Balance(FCY)": "export_due_amount",
        "Created Time": "created_at",
        "Updated Time": "updated_at"
      },
      ref_no: "",
      retainer_notes: "",
      refund_amount: "",
      available_amount: "",
      used_amount: "",
      logrecords: "", // to show log of popup funcitons
      value: [],
      modalPage: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      // locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      checkboxes1: [],
      CheckedCount: 0
    };
  },
  components: {
    DeleteRecord,
    LogRecord,
    RecordNotFound
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  methods: {
    //refresh List
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status||store.state.retainer.index_status || 1;
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("retainer/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status
            }
          });
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },
    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status ||store.state.retainer.index_status|| 1;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("retainer/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom
        })
        .then(() => {
          if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
           if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
            this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
          }
        });
      return response;
    },

    //  detelted record details
    getDelete() {
      this.submitted - true;
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || 1;
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("retainer/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          update: update_status
        })
        .then(async () => {
          this.page = await (this.lists.length == 0 && this.page != 1
            ? (this.page = 1)
            : this.page);
          this.show = show;
          this.status = status;
          this.label = label;
          this.$route.params.sort = sort;
          await this.$router.push({
            query: {
              page: this.page,
              show: this.show,
              search: search,
              status: status,
              update: update_status,
              sort: sort,
              label: label
            }
          });
        });
         if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }

    },
    //  call delete modal
    deletemodal() {
      var ids = this.checkboxes1;
      ids = ids.filter(item => item !== false && item !== true);
      this.value = ids;
      this.$root.$emit("bv::show::modal", "invoicedelete");
    },
    checkAll(ev) {
      this.check_index = [];
      var fields = this;

      fields.lists.map(function(value, index) {
        fields.checkboxes1[index + 1] =
          ev.target.checked == true ? value.retainer_hdr_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var retainer_hdr_ids = this.checkboxes1;
      retainer_hdr_ids = retainer_hdr_ids.filter(item => item !== false);
      // check all if page length matches
      if (retainer_hdr_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }
      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
    // to filter the json data - to get any particular data from json
    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    }
  },

  created() {
    //     // this.initializationMessengerCode();
    //     // Messenger.options = {
    //     //   extraClasses: this.locationClasses,
    //     //   theme: "air"
  },
  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.state.retainer.index_status=store.state.settings.status_code==404?'': store.state.retainer.index_status
    store.dispatch("retainer/fetchRetainerInvoiceDetails");
    getPageRetainers(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
     store.state.retainer.index_status = "";
    getPageRetainers(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },
    beforeRouteLeave(to, from, next) {
    store.state.retainer.retainer_index_history = from.fullPath;
    store.state.retainer.index_status = from.params.status;
    store.state.settings.status_code=''
    next();
  },

  //computed properties
  computed: {
    ...mapState({
      lists: state => state.retainer.lists,
      total_count: state => state.retainer.total_count,
      count: state => state.retainer.count,
      search_criteria: state => state.retainer.search_criteria,
      is_no_records: state => state.retainer.is_no_records, // to check for an record in the database
      filter_list: state => state.retainer.filter_list, // to show the  dropdown of filter list name inside the table file: retainer.js
      filter_name: state => state.retainer.filter_name, // to show the  name of the selected filter list name inside the table file: retainer.js
      message: state => state.retainer.log_details,
      export: state => state.retainer.export,
      status_code: state => state.retainer.status_code, 
      status_message: state => state.retainer.status_message, 
      status_type: state => state.retainer.status_type,
    })
  }
};
</script>
